import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function DrawSquare({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.458 13.7078L12.292 16.4282C12.1415 16.779 11.7955 17.0053 11.4138
        17.0026C11.0322 16.9999 10.6894 16.7686 10.5439 16.4158L7.30004 8.53901C7.15419
        8.18499 7.23555 7.778 7.50629 7.50726C7.77702 7.23652 8.18402 7.15516 8.53803
        7.30101L16.4148 10.5449C16.7677 10.6903 16.9989 11.0332 17.0016 11.4148C17.0043
        11.7964 16.778 12.1425 16.4273 12.293L13.7069 13.459C13.595 13.5068 13.5059
        13.596 13.458 13.7078V13.7078Z'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M3.99431 11.9678L2.99805 12.964'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.98538 1.00781V2.41645'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M2.99805 2.99805L3.99431 3.99431'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.00781 7.98636H2.41645'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12.9631 2.99805L11.9668 3.99431'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

DrawSquare.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default DrawSquare
